<section class="page">
  <header class="page-header">
    <div>
      <h1>Rent payments</h1>
      <p>Paginated rent payment activity</p>
    </div>
  </header>

  @if (error()) {
    <div class="alert alert-error">{{ error() }}</div>
  }

  <div class="panel">
    <div class="table-wrap">
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>User</th>
            <th>Amount</th>
            <th>Bank charged</th>
            <th>Rewards used</th>
            <th>Landlord</th>
            <th>Property</th>
            <th>Status</th>
            <th>Due</th>
            <th>Paid</th>
          </tr>
        </thead>
        <tbody>
          @if (loading()) {
            <tr><td colspan="10" class="muted">Loading…</td></tr>
          } @else if (!rows().length) {
            <tr><td colspan="10" class="muted">No rent payments</td></tr>
          } @else {
            @for (row of rows(); track row.id) {
              <tr>
                <td>{{ row.id }}</td>
                <td>{{ userLabel(row) }}</td>
                <td>{{ row.rent_amount }} {{ row.currency || '' }}</td>
                <td>{{ row.bank_amount_charged ?? '—' }}</td>
                <td>{{ row.reward_amount_used ?? '—' }}</td>
                <td>{{ row.landlord_name || '—' }}</td>
                <td>{{ row.property_address || '—' }}</td>
                <td>
                  <span class="badge" [attr.data-status]="row.status">{{ row.status || '—' }}</span>
                </td>
                <td>{{ row.due_date || '—' }}</td>
                <td>{{ row.paid_at ? (row.paid_at | date: 'medium') : '—' }}</td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>

    <div class="pager">
      <span class="muted">Page {{ page() }} of {{ totalPages() }} · {{ total() }} total</span>
      <div class="pager-actions">
        <button class="btn btn-secondary" type="button" (click)="prev()" [disabled]="page() <= 1 || loading()">
          Previous
        </button>
        <button
          class="btn btn-secondary"
          type="button"
          (click)="next()"
          [disabled]="page() >= totalPages() || loading()"
        >
          Next
        </button>
      </div>
    </div>
  </div>
</section>
